import React from "react";

const ProductDetailsSkeleton = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-md animate-pulse">
      {/* Breadcrumb */}
      <div className="mb-4 h-4 w-48 bg-gray-300 rounded"></div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left: Image Gallery */}
        <div className="flex gap-3">
          <div className="flex flex-col gap-2">
            <div className="w-16 h-16 bg-gray-300 rounded"></div>
            <div className="w-16 h-16 bg-gray-300 rounded"></div>
            <div className="w-16 h-16 bg-gray-300 rounded"></div>
          </div>
          <div className="w-[500px] h-[400px] bg-gray-300 rounded"></div>
        </div>

        {/* Right: Details */}
        <div className="flex-1 space-y-4">
          <div className="h-6 w-64 bg-gray-300 rounded"></div> {/* Title */}
          <div className="h-4 w-24 bg-gray-300 rounded"></div> {/* Rating */}
          <div className="h-4 w-32 bg-gray-300 rounded"></div> {/* Price */}
          <div className="h-4 w-48 bg-gray-300 rounded"></div> {/* Brand */}
          <div className="h-4 w-96 bg-gray-300 rounded"></div>{" "}
          {/* Description */}
          <div className="flex space-x-3 mt-4">
            <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
            <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
            <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
          </div>
          <div className="flex items-center gap-4 mt-4">
            <div className="h-10 w-24 bg-gray-300 rounded"></div>{" "}
            {/* Quantity */}
            <div className="h-10 w-40 bg-gray-300 rounded"></div>{" "}
            {/* Add to Cart */}
            <div className="h-10 w-10 bg-gray-300 rounded-full"></div>{" "}
            {/* Heart */}
          </div>
          <div className="space-y-2 mt-6">
            <div className="h-4 w-40 bg-gray-300 rounded"></div>
            <div className="h-4 w-64 bg-gray-300 rounded"></div>
            <div className="h-4 w-80 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsSkeleton;
